<app-text (click)="addBuilding()" class="has-text-netatmo">
  {{ 'iaq-app.__IAQ_NEW_BUILDING' | AsyncLang | async }}
</app-text>
